<template>
  <div class="bg-white rounded p-5 shadow-light-2">
    <h3 class="font-semibold text-xl text-hurst-light-blue">School/Promo Code</h3>
    <form @submit.prevent="applyCode" v-if="cart.orgCode === null">
      <label class="sr-only" for="orgCode">Enter your School/Promo code</label>
      <input type="text" id="orgCode"
             v-model="orgCode"
             class="mt-4 block w-full px-4 py-2.5 rounded border border-hurst-blue placeholder:text-hurst-light-blue placeholder:opacity-35"
             required placeholder="promocode123">
      <button type="submit" class="font-bold text-hurst-blue text-sm py-2 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 mr-0.5">
          <path
              d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"/>
        </svg>
        Apply Code
      </button>
    </form>
    <div v-else class="py-4">
      <div class="p-4 bg-[#6CFFD5] text-xs text-[#00352F] font-semibold">
        Your discount code {{ cart.registrationCode ?? cart.orgCode.orgCode }} has been applied
      </div>
      <button type="button"
              @click.prevent="removeCode"
              class="font-bold text-hurst-blue text-sm py-2 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 mr-0.5">
          <path fill-rule="evenodd" d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z"
                clip-rule="evenodd"/>
        </svg>
        Remove
      </button>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('cart');

export default {
  name: "CartOrgCodeForm",

  data() {
    return {
      dirty: false,
      errors: [],
      orgCode: '',
      tzOffset: (new Date()).getTimezoneOffset()
    };
  },

  computed: {
    ...mapState({
      cart: state => state.cart,
    }),
  },

  watch: {
    orgCode: function () {
      this.dirty = true;
    }
  },

  methods: {
    ...mapActions(['addCode', 'deleteCode']),

    async applyCode(event, force = false) {
      if ((this.orgCode.length > 0 && this.dirty) || force) {
        Swal.fire({
          icon: 'info',
          title: '<i class="fal fa-spinner fa-spin"></i>',
          text: 'Applying code to your purchase',
          showCloseButton: false,
          showConfirmButton: false
        });

        try {
          await this.addCode({orgCode: this.orgCode, tzOffset: this.tzOffset});
          this.orgCode = '';
          this.$emit('code-changed');
          Swal.close();
        } catch (e) {
          Swal.close()
          const data = e.response.data.errors
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: data[0],
            showConfirmButton: true,
            showCloseButton: false,
          })
        }
        this.dirty = false;
      }
    },
    removeCode() {
      this.deleteCode();
      this.$emit('code-changed');
    }
  },
}
</script>

<style scoped>

</style>